export default function normalizeStaticPageTitle(title) {
  if (title == null || typeof title !== "string") {
    return null;
  }

  const trimmed = title.trim();

  if (!trimmed || trimmed === '""' || trimmed === "''") {
    return null;
  }

  return trimmed;
}
